import { WBBox, WBTypography } from '@admiin-com/ds-web';
import AdmiinLogo from '../../../components/AdmiinLogo/AdmiinLogo';
import { useTranslation } from 'react-i18next';
import { PageContainer } from '../../../components';
import OnboardingBusinessAddressForm from './OnboardingBusinessAddressForm';

const OnboardingBusinessAddressLookup = () => {
  const { t } = useTranslation();
  return (
    <PageContainer
      sx={{
        flexDirection: 'column',
        alignItems: 'center',
        paddingY: 6,
      }}
    >
      <WBBox
        sx={{
          mb: { md: 5, xs: 1 },
          display: 'flex',
          justifyContent: 'center',
        }}
      >
        <AdmiinLogo />
      </WBBox>
      <WBTypography variant="h3" mt={3}>
        {t('onboardingBusinessAddressTitle', { ns: 'onboarding' })}
      </WBTypography>

      <WBTypography variant="body2" color="text.secondary" mb={[3, 15]}>
        {t('onboardingBusinessAddressBody', { ns: 'onboarding' })}
      </WBTypography>
      <OnboardingBusinessAddressForm />
    </PageContainer>
  );
};
export default OnboardingBusinessAddressLookup;
